<template>
    <div class="box-warranty-check container-fluid">
        <ProductInfo v-if="isShow" :lstData="settings" :key="componentKeyInfo"/>
        <FormInfo v-if="isShow" :lstData="settings" :key="componentKeyForm"/>
        <AppInfo v-if="isShow" :lstData="settings" :key="componentKeyApp"/>
        <Footer v-if="isShow" :lstData="settings" :key="componentKey"/>
    </div>
</template>

<script>
import ProductInfo from './product_info'
import FormInfo from './form_check'
import AppInfo from './app_info_check'
import Footer from './footer'
import DataServices from '@/core/DataServices'
export default {
    components: {
        Footer,
        AppInfo,
        FormInfo,
        ProductInfo
    },
    data() {
        return {
            settings: [],
            keyword: '',
            isShow: false,
            componentKey: Math.random() * 301,
            componentKeyApp: Math.random() * 201,
            componentKeyForm: Math.random() * 101,
            componentKeyInfo:  Math.random() * 401
        }
    },
    mounted () {
        this.getSettings();
        this.checkSerialNumber();
    },
    methods: {
        async getSettings() {
            var data = await DataServices.getList('settings', {'fields' : 'key value'});
            if (data != undefined && data != null && data[Object.keys(data)].length) {
                var objs =  data[Object.keys(data)];
                this.settings = objs;
                this.componentKey = Math.random() * 301;
                this.componentKeyApp = Math.random() * 201;
                this.componentKeyForm = Math.random() * 101;
                this.componentKeyInfo = Math.random() * 401;
            }
        },
        async checkSerialNumber() {
            if (this.$route.params.keyword == undefined || (this.$route.params.keyword != undefined && this.$route.params.keyword.length == 0)) window.location = window.origin + '/check-warranty';
            else {
                var keyword = this.$route.params.keyword.trim();
                if (keyword.length > 0) {
                    this.productSerialNumber = keyword;
                    var variables1 = {
                        where_key: {
                            serial_number: {'_eq': keyword },
                            production_status: {'_eq': 1},
                            status: {'_eq': 1}
                        }
                    }
                    var data1 = await DataServices.getList('product_serial_number', {"variables": JSON.stringify(variables1), "fields": "warranty_status product { thumbnails { external_path cdn_path local_path} name model_code returnable_time returnable_unit warranty_time warranty_unit slug desc_product_application desc_product_advantages} product_serial_number_info { name model_code returnable_time warranty_time warranty_status verify_status activation_date warranty_unit returnable_unit}"});
                    var list1 = data1[Object.keys(data1)];
                    if (list1 == undefined || (list1 && Object.keys(list1).length == 0)) {
                        window.location.href = window.origin+ '/check-warranty';
                    } else {
                        this.isShow = true;
                    }
                }
            }
        }
    }
}
</script>

<style lang="scss">
 body{background:#fff ; overflow-x: hidden;
    .box-warranty-check{padding: 0;
        .box-form-check-header{
            .box-logo{display: none;}
            .border-box{display: none;}
            .box-check-body{width: 945px; background: #e9f6fc; border: 0.75px solid #b4e0f3; margin: 0 auto; border-radius: 15px; padding-bottom: 37.5px; position: relative; z-index: 100;
                .description{display: block; font-size: 17px; line-height: 22px; font-family: 'Roboto'; font-style: normal; font-weight: normal; color: #636366;}
            }
        }
        .box-form-check{margin-top: 0;
            .box-form-check-header{text-align: center; padding: 0; position: relative;
                .box-absolute{ position: absolute; left: 0;   right: 0;  margin-left: auto;  margin-right: auto;
                    .title{font-size: 36px; line-height: 54px; 
                        span{font-weight: 900;}
                    } 
                }
            }
        }
        .box-app-info {padding-top: 128px;
            &::before{content: ""; position: absolute; overflow: hidden; width: 104%;height:300px; left: -4%; top: -6%; z-index: -1;  background: #f5f5f7; transform: rotate(2deg); }
            .box-app-check-body { margin-top: 55px;
                .box-app-check-body-item{
                    .download-info{
                        .download-link{margin-top: 23px;}
                    }
                }
            }
        }
        .box-product-info{
            .box-product-top{margin-bottom: 164px;
                &::before{ content: ""; position: absolute; overflow: hidden; width: 104%; height: 100%; left: -4%; top: 17%; z-index: -1; background: #26a2d6; transform: rotate(-2deg);}
            }
        }
    }
    
    .error{color: #f00;}
 }
@media screen  and (max-width: 1366px) and (min-width: 991px){
    .box-app-info {
        .box-app-check-body {
            .box-app-check-body-item {width: 450px;
                &.app-check-body-right{margin-left: 10px; width: 500px;
                    .download-info {
                        .download-info-item {
                            .display-flex {
                                &.download-info-item-right{width: calc(100% - 100px);}
                            }
                        }
                    }
                }
            }
        }
    }
}
@media screen  and (max-width: 991px){
    .box-product-info{
        .box-product-top{
            .box-product-body{
                .logo{margin-top: 33.8px;  margin-bottom: 33.8px;        
                    img{width: 67px; height: 56px;}
                }
                .box-product-body-top{
                    .box-product-body-info{
                        .product-status{display: inline-block; line-height: 38px; font-size: 14px;  padding: 0 20px;}
                    }
                }
            }
        }
    }
    .box-warranty-check {
        .box-product-info {
            .box-product-top {
                .box-product-body {padding: 0 11.25px ;
                    .box-product-body-top {
                        .box-product-body-info {
                            .product-title{width: 100%; font-size: 30px; line-height: 130%;}
                            .product-info{width: 100%;
                                .box-all-info {
                                    .box-item-info {
                                        .box-col-info{width: 172px; float: left;  min-width: auto !important; margin-right: 0;
                                            &:nth-child(2){width: 161px; float: right;}
                                        }
                                    }
                                }
                            }
                            .link-policy{margin-bottom: 22.07px;}
                        }
                        
                        .box-product-body-img { margin-top: 20px;
                            .box-product-img {width: 100%; height: 100%; }
                        }
                    }
                }
            }
            .box-product-body-bottom {padding: 0 11.25px ; width: 100%;
                .guide {width: 100%; float: none;
                    img{width: 56px;}
                    &:first-child {margin-bottom: 32px;}
                    .guide-title { font-size: 30px !important; line-height: 35px !important;
                        span {padding-bottom: 10.5px;}
                        
                    }
                    .btn-link-open {width:258.75px;margin: 0 auto; 
                        img{width: 16.50px; height: 16.50px;}
                    }
                }
                .box-product-app{
                    .guide {
                        .description{font-size: 17px; line-height: 140%;}
                    }
                }
            }
        }
        
        .box-form-check {padding: 0; margin-top: 0;
            .row {margin: 0; }
            .box-form-check-header{
                .box-check-body {width: 100% !important; padding: 10.50px 18.00px;
                    .form-input {width: 100%; margin-bottom: 24px;
                        .form-input-group{height: 58px;
                            button{height: 42px;}
                        }
                    }
                    .title{font-size: 30px !important; line-height: 35px !important;}
                    .description{margin-top: 5px; font-family: 'Roboto'; font-style: normal; font-weight: normal; font-size: 17px; line-height: 22px; color: #636366;}
                }
            }
        }
        
        .box-app-info {padding: 11.25px; margin-top: 75.23px; padding-bottom: 37.5px; padding-top: 185px !important;
            .box-app-check-body { 
                .download-title-mobile{display: block; text-align: center; margin-bottom: 24.00px; font-size: 30px; line-height: 35px;}
                .border-box-app-mobile{display: block; margin: 0 auto;}
                .box-app-check-body-item { float: none; width: 100%; text-align: center;
                    &.app-check-body-right{margin: 0;text-align: left; height: auto; 
                        .border-box-app{display: none;}
                        .download-title{display: none;}
                        .download-info{margin-top: 16.11px;
                            .download-link{margin-top: 24px; /*margin-left: 15px;*/
                                .image-store {width: 135px; height: 40px; display: inline-block;
                                    img{height: auto !important; width: auto !important; }
                                }
                            }
                            // .download-info-item{
                            //     .download-info-item-right{width: calc(100% - 130px) !important;}
                            // }
                            .download-info-item{margin-left: 0; margin-right: 10px; width: 100%;
                                .download-info-item-right{width: calc(100% - 121px) !important;}
                                .download-info-item-img {
                                    img{margin-top: 15px;}
                                }
                            }
                        }
                    }
                }
            }
        }
        .footer-check { height: 124px !important;  display: flex; align-items: center;
            .footer-format{padding: 0 !important; height: auto !important;
                .footer-policy{float: none !important; }
                .footer-info{float: none !important; margin-top: 12px; font-size: 17px !important; line-height: 22px !important;}
            }
        }
        .box-product-slug{ height: 48px; width: 100% !important; float: none !important; display: flex; justify-content: center;
            .btn-link-open{height: 48px !important;font-family: 'Roboto'; font-style: normal; font-weight: 500; font-size: 15px; line-height: 22px;}
        }
    }
 }
@media screen  and (max-width: 767px){
    .box-warranty-check {
        .box-app-info {padding-top: 255px !important; position: relative;
            &::before{top: -2% !important;}
        }
        .box-product-info {
            .box-product-top::before {
                width: 106% !important;
                height: 180px !important;
                left: -5% !important;
                top: 90% !important;
                transform: rotate(-2deg )!important;
            }
            .box-product-top {
                .box-product-body {padding: 0 11.25px ;
                    .box-product-body-top {
                        .box-product-body-info {
                            .product-title{width: 100%; font-size: 30px; line-height: 130%;}
                            .product-info{width: 100%;
                                .box-all-info {
                                    .box-item-info {
                                        .box-col-info{width: 166px; float: left;  min-width: auto !important; margin-right: 0;
                                            &:nth-child(2){width: 155px; float: right;}
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

        }
    }
    .box-product-slug{ width: 100% !important; float: none !important; display: flex; justify-content: center;
       .btn-link-open {margin: 0 !important;}
    }
    .box-product-info {
        .box-product-top {
            .box-product-body{
                .box-product-body-top {
                    .box-product-body-img {
                        .box-product-img { height: 320px !important; width: 320px !important; margin: 0 auto !important; justify-content: center; right: auto; display: inline-flex;}
                    }
                }
            }
        }
        .box-product-body-bottom {position: relative;  margin-top: 357px; margin-bottom:37.5px !important;
            .box-product-body-bottom-board {margin:0 !important;}
        }
    }
    .box-app-check-body-item{min-width: inherit !important; height: auto !important; 
        img{height: auto !important;}
    }
    
}
@media screen  and (max-width: 756px) and (min-width: 575px){
    .box-app-info {
        .box-app-check-body {
            .box-app-check-body-item {
                &.app-check-body-right{
                    .download-info{
                        .download-info-item{
                            .download-info-item-img {height: 63px;}
                        }
                    }
                }
            }
        }
    }
}
@media screen  and (max-width: 441px){
    .box-product-slug{
        .btn-link-open{width: 100% !important;}
    }
}
@media screen  and (max-width: 360px){
    .box-warranty-check .box-app-info{padding-top: 255px !important;}
}
@media screen  and (max-width: 320px){
    .box-warranty-check {
        .box-product-info {
            .box-product-top {
                .box-product-body {
                    .box-product-body-top {
                        .box-product-body-info {
                            .product-info{
                                .box-all-info {
                                    .box-item-info {
                                        .box-col-info{width: 155px; float: left;  min-width: auto !important; margin-right: 0;
                                            &:nth-child(2){width: 140px; float: right;}
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>